import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { errorMessage } from "../../utils/errorMessage";

export const actionToGetResultOfHepsiBuradaUpload = createAsyncThunk(
  "jobInActionToGetResultOfHepsiBuradaUpload",
  async ({ batchRequestId, productId }, thunkAPI) => {
    const token = thunkAPI.getState().adminUserToLogin.adminUserInfo.token; // Gets the current Redux state

    try {
      // Call your API function here
      const { data } = await axios.get(
        "/api/hepsiBurada/getResultOfHepsiBuradaUpload",
        {
          params: {
            batchRequestId,
            productId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data;
    } catch (error) {
      const { message } = errorMessage(error);

      throw new Error(message);
    }
  }
);

const getResultOfHepsiBuradaUpload = createSlice({
  name: "sliceToGetResultOfHepsiBuradaUpload",
  initialState: {
    batchResult: {},
    loading: false,
    error: null,
  },
  reducers: {
    resetGetResultOfHepsiBuradaUploadIsUploaded: (state) => {
      state.isSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actionToGetResultOfHepsiBuradaUpload.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        actionToGetResultOfHepsiBuradaUpload.fulfilled,
        (state, action) => {
          state.loading = false;
          state.error = null;
          state.isSuccess = true;
          state.batchResult = action.payload;
        }
      )
      .addCase(
        actionToGetResultOfHepsiBuradaUpload.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        }
      );
  },
});

export const { resetGetResultOfHepsiBuradaUploadIsUploaded } =
  getResultOfHepsiBuradaUpload.actions;

const reducerToGetResultOfHepsiBuradaUpload =
  getResultOfHepsiBuradaUpload.reducer;

export default reducerToGetResultOfHepsiBuradaUpload;
